import { createSlice } from "@reduxjs/toolkit";
import { sendOtp, verifyOtp, checkSession, logout } from "../thunks/authThunks";

const storedUser = (() => {
  try {
    const raw = localStorage.getItem("gms_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
})();

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: storedUser,
    isAuthenticated: !!storedUser,
    isAdmin: storedUser?.role === "admin" || storedUser?.role === "superadmin",
    isSuperAdmin: storedUser?.role === "superadmin",
    loading: true, // true until checkSession resolves
    error: null,
  },
  reducers: {
    clearAuthError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // sendOtp
    builder
      .addCase(sendOtp.pending, (state) => {
        state.error = null;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.error = action.payload;
      });

    // verifyOtp
    builder
      .addCase(verifyOtp.pending, (state) => {
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        const user = action.payload.user;
        state.user = user;
        state.isAuthenticated = true;
        state.isAdmin = user.role === "admin" || user.role === "superadmin";
        state.isSuperAdmin = user.role === "superadmin";
        state.error = null;
        localStorage.setItem("gms_user", JSON.stringify(user));
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.error = action.payload;
      });

    // checkSession
    builder
      .addCase(checkSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkSession.fulfilled, (state, action) => {
        const p = action.payload;
        const user = {
          id: p.id, phone: p.phone, name: p.name, role: p.role,
          state: p.state, acNames: p.acNames, acNumbers: p.acNumbers,
          mandals: p.mandals, lastLocation: p.lastLocation,
          lastLocationArea: p.lastLocationArea, lastLocationAt: p.lastLocationAt,
        };
        state.user = user;
        state.isAuthenticated = true;
        state.isAdmin = user.role === "admin" || user.role === "superadmin";
        state.isSuperAdmin = user.role === "superadmin";
        state.loading = false;
        state.error = null;
        localStorage.setItem("gms_user", JSON.stringify(user));
      })
      .addCase(checkSession.rejected, (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.isAdmin = false;
        state.isSuperAdmin = false;
        state.loading = false;
        localStorage.removeItem("gms_user");
      });

    // logout
    builder
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.isAdmin = false;
        state.isSuperAdmin = false;
        state.error = null;
        localStorage.removeItem("gms_user");
      })
      .addCase(logout.rejected, (state) => {
        // Clear locally even if server call fails
        state.user = null;
        state.isAuthenticated = false;
        state.isAdmin = false;
        state.isSuperAdmin = false;
        localStorage.removeItem("gms_user");
      });
  },
});

export const { clearAuthError } = authSlice.actions;
export default authSlice.reducer;
